import React, { Component } from 'react'
import { Colors } from '../../../../Styles/Colors'
import { Box, Button, Checkbox, FormControlLabel, Grid, IconButton, Table, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import { ImagePaths } from '../../../../Utility/ImagePaths'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { Doctor_Notes_OPT_Right_Layout_JSON, Doctor_Notes_OPT_Left_Layout_JSON, Other_Doctor_Notes_Layout_JSON, Doctor_Notes_OPTHOMETRY_Right_Layout_JSON, Doctor_Notes_OPTHOMETRY_Left_Layout_JSON } from '../../../../Utility/Constants'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { localGetItem, localSetItem } from '../../../../Utility/Services/CacheProviderService'

const defaultAddNew = { field_name: '', label: '', custom_name: '', is_active: false, is_new: true };

export default class DocLayoutConfig extends Component {
    constructor(props) {
        super(props)
        this.state = {
            right_Fields_data: [],
            left_Fields_data: [],
            isErrorMsg: false,
            isErrorMsgText: "",
            drag_label: null,
            drag_label_left: null,
            tblBillData: [],
            isOPT: false,
            isOpthometry: false,
            newLayoutData: [],
            isOBGYN: false,
            max_new_layout_alloted: 0,
            new_layout_count: 0,
            org_new_layout_count: 0,
        }
        this.labelRefs = {};
    }

    componentDidMount = () => {
        let ServiceType = localGetItem("loggedInUserInfo")
        let myUser = JSON.parse(ServiceType)
        this.setState({
            isOPT: myUser.service_type === "OPT" ? true : false,
            isOpthometry: myUser.service_type === "OPTOMETRY" ? true : false,
            isENT: myUser.service_type === "ENT" ? true : false,
            isOBGYN: myUser.service_type === "OBGYN",
        }, () => { this.getLayoutConfiguration() })
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    deepCopyObj = (data) => {
        return JSON.parse(JSON.stringify(data));
    }

    returnDefaultLayout(Side, fromReset = false) {
        let userInfo = JSON.parse(localGetItem("loggedInUserInfo") || "{}");
        let isNewOtherDoc = userInfo?.new_doctor_notes_template_others === true;
        let isNewBilling = localGetItem("isNewBilling") === 'true';
        if (Side === "right") {
            if (this.state.isOPT) {
                return this.deepCopyObj(Doctor_Notes_OPT_Right_Layout_JSON);
            } else if (this.state.isOpthometry) {
                return this.deepCopyObj(Doctor_Notes_OPTHOMETRY_Right_Layout_JSON);
            } else {
                return [];
            }
        } else if (Side === "left") {
            let Doctor_Notes_Layout = this.deepCopyObj(Other_Doctor_Notes_Layout_JSON);

            let filteredLayout = Doctor_Notes_Layout.filter((item) => {
                // Exclude Counselling if new billing
                // if (item.field_name === 'counselling' && isNewBilling) return false;

                // Exclude other fields if new doctor notes template is enabled
                if (isNewOtherDoc && ['clinical_history', 'past_history', 'history_of_presenting_illness'].includes(item.field_name)) {
                    return false;
                }

                if(!isNewOtherDoc && ['clinical_diagram'].includes(item.field_name)){
                    return false;
                }

                return true;
            });

            if (this.state.isOPT) {
                return this.deepCopyObj(Doctor_Notes_OPT_Left_Layout_JSON);
            } else if (this.state.isOpthometry) {
                return this.deepCopyObj(Doctor_Notes_OPTHOMETRY_Left_Layout_JSON);
            } else {
                const isAddLayout = (this.state.max_new_layout_alloted - this.state.new_layout_count) !== 0;

                if (this.state.isENT) {
                    const isAlreadyAdded = filteredLayout.some(item => item.field_name === 'clinicExam');
                    if (!isAlreadyAdded) {
                        filteredLayout.push({
                            id: this.getNextId(filteredLayout),
                            field_name: 'clinicExam',
                            label: 'Clinical Examination',
                            custom_name: 'Clinical Examination',
                            is_active: true
                        });
                    }
                }

                if (this.state.isOBGYN) {
                    const isAlreadyAdded = filteredLayout.some(item => item.field_name === 'obstetric_data');
                    if (!isAlreadyAdded) {
                        filteredLayout.push({
                            id: this.getNextId(filteredLayout),
                            field_name: 'obstetric_data',
                            label: 'Obstetric Data',
                            custom_name: 'Obstetric Data',
                            is_active: false
                        });
                    }
                }

                if (fromReset) {
                    const isAddLayout = (this.state.max_new_layout_alloted - this.state.org_new_layout_count) !== 0;
                    let newDocLayout = [...filteredLayout, ...this.state.newLayoutData];
                    if (isAddLayout) {
                        newDocLayout.push(this.deepCopyObj({
                            ...defaultAddNew,
                            id: this.getNextId(newDocLayout)
                        }));
                    }

                    // 🔧 Fix duplicated IDs before returning
                    return this.deepCopyObj(this.fixDuplicateIds(newDocLayout));
                }

                if (isAddLayout) {
                    filteredLayout.push(this.deepCopyObj({
                        ...defaultAddNew,
                        id: this.getNextId(filteredLayout)
                    }));
                }

                // 🔧 Fix duplicated IDs before returning
                return this.deepCopyObj(this.fixDuplicateIds(filteredLayout));
            }
        }
    }

    fixDuplicateIds = (layout) => {
        const usedIds = new Set();
        return layout.map(item => {
            let newItem = { ...item };
            newItem.id = Number(newItem.id); // Ensure numeric

            if (!usedIds.has(newItem.id)) {
                usedIds.add(newItem.id);
            } else if (newItem.is_already_add || newItem.is_new) {
                // ID conflict, generate a unique one
                let newId = 1;
                while (usedIds.has(newId)) newId++;
                newItem.id = newId;
                usedIds.add(newId);
            } else {
                console.warn("⚠️ Duplicate ID found in base layout:", newItem);
            }

            return newItem;
        });
    };


    getNextId = (layout) => {
        let maxId = layout.reduce((max, item) => Math.max(max, item.id), 0);
        return maxId + 1;
    };

    getLayoutConfiguration = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_LAYOUT)
                .then((response) => {
                    if (response.data.status === "success") {
                        const { field_data, max_new_layout_alloted, new_layout_count } = response.data.data;
                        const isAddLayout = (max_new_layout_alloted - new_layout_count) !== 0;
                        const modifiedLeftData = field_data?.left_data?.map(item => 
                            item.is_new ? { ...item, is_already_add: true } : { ...item }
                        );
                        const isOptho = (this.state.isOPT || this.state.isOpthometry);
                        // store in localStorage
                        localSetItem("DoctorNotesLayout", JSON.stringify(response.data.data));
                        this.setState({
                            right_Fields_data: field_data?.right_data ? field_data?.right_data : this.returnDefaultLayout("right"),
                            left_Fields_data: field_data?.left_data
                                ? (isOptho ? field_data?.left_data :
                                    [...modifiedLeftData,
                                    ...(isAddLayout ? [this.deepCopyObj({ ...defaultAddNew, id: this.getNextId(modifiedLeftData) })] : [])
                                    ])
                                : this.returnDefaultLayout("left"),
                            ...(isOptho ? {} : {
                                newLayoutData: field_data?.left_data
                                    ? this.deepCopyObj(modifiedLeftData.filter(item => item.is_new))
                                    : [],
                                max_new_layout_alloted,
                                new_layout_count,
                                org_new_layout_count: new_layout_count,
                            }),
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.setState({
                            right_Fields_data: this.returnDefaultLayout("right") ,
                            left_Fields_data: this.returnDefaultLayout("left") , 
                        })
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.setState({
                            right_Fields_data: this.returnDefaultLayout("right") ,
                            left_Fields_data: this.returnDefaultLayout("left") , 
                        })
                        this.errorMessage(error.message)
                    }
                })

        } catch (e) {
            this.errorMessage(e.message)
        }
    }

    convertLowerCase = (data) => {
        return data?.toLowerCase()
    }

    postLayoutConfiguration = () => {
        try {
            var states = this.state
            var data = {
                "right_data": states.right_Fields_data,
                "left_data": states.left_Fields_data?.reduce((acc, item) => {
                     // Skip items where both are empty
                    if (((!item.label && !item.custom_name && item.field_name === "" && item.is_newly_add === undefined) ||
                        (item.label && item.custom_name && item.field_name === "" && item.is_newly_add === undefined))) {
                        return acc;
                    }

                    const { is_newly_add, ...itemWithoutIsNewlyAdd } = item;  

                    acc.push(item.is_new
                        ? { ...itemWithoutIsNewlyAdd, field_name: item.label?.toLowerCase()?.replace(/\s+/g, "_") } 
                        : itemWithoutIsNewlyAdd
                    );
                
                    return acc;
                }, [])
            }
            let msg = null;
            const nameSet = new Set();
            const labelSet = new Set();

            if (!this.state.isOPT && !this.state.isOpthometry) {
                data.left_data?.forEach((item) => {
                    if (!item.label || !item.custom_name) {
                        msg = `Please enter ${!item.label ? "system name" : "custom name"}`;
                        return;
                    }
                    if (labelSet.has(this.convertLowerCase(item.label)) || nameSet.has(this.convertLowerCase(item.custom_name))) {
                        msg = `${labelSet.has(item.label) ? "System" : "Custom"} Name is duplicate`;
                        return;
                    }
                    labelSet.add(this.convertLowerCase(item.label));
                    nameSet.add(this.convertLowerCase(item.custom_name));
                });
            }

            if (msg) {
                this.errorMessage(msg)
            } else {
                RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_LAYOUT)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            this.successMessage(response.data.message)
                            this.getLayoutConfiguration()
                        }
                    }).catch((error) => {
                        if (error?.response?.data?.message) {
                            this.errorMessage(error.response.data.message)
                        } else {
                            this.errorMessage(error.message)
                        }
                    })
            }

        } catch (e) {
            this.errorMessage(e.message)
        }
    }


    handleDragLeft = (e) => {
        this.setState({
            drag_label_left: e.currentTarget.id
        })
    }

    handleCheckClickLeft = (e) => {
        var { left_Fields_data } = this.state

        const ID = e.target.id;
        const Index = left_Fields_data.findIndex((data) => {
            return data.id == ID;
        });

        left_Fields_data[Index].is_active = e.target.checked;

        let lastChangedIndex = Index;

        for (let i = 0; i < left_Fields_data.length; i++) {
            if (i !== Index && left_Fields_data[i].is_active) {
                lastChangedIndex = i;
                break;
            }
        }

        if (left_Fields_data.every(data => !data.is_active)) {
            left_Fields_data[lastChangedIndex].is_active = true;
        }

        this.setState({
            left_Fields_data
        })
    }

    handleDropLeft = (e) => {
        var states = this.state
        const dragBox = (states.left_Fields_data).find((field) => field.label === states.drag_label_left);
        const dropBox = (states.left_Fields_data).find((field) => field.label === e.currentTarget.id);

        const matchingObject = (states?.right_Fields_data).find((item) => item.label === states?.drag_label);

        if (matchingObject) {
            this.errorMessage("Not Allow to Drag Right side values into Left")
            this.setState({
                drag_label: null
            })
        } else {
            const dragBoxID = dragBox.id;
            const dropBoxID = dropBox.id;

            const dragBoxField = dragBox.field_name;
            const dropBoxField = dropBox.field_name;

            const dragBoxCheck = dragBox.is_active;
            const dropBoxCheck = dropBox.is_active;

            // To make the default field also draggable.
            const dragBoxDefault = dragBox.is_default;
            const dropBoxDefault = dropBox.is_default;

            const newBoxState = (states.left_Fields_data).map((field) => {
                if ((!dragBoxDefault && !dropBoxDefault) || (dragBoxDefault && dropBoxDefault)) {
                    if (field.label === states.drag_label_left) {
                        field.id = dropBoxID;
                        field.field_name = dragBoxField;
                        field.is_active = dragBoxCheck;
                        field.is_default = dragBoxDefault;
                    }
                    if (field.label === e.currentTarget.id) {
                        field.id = dragBoxID;
                        field.field_name = dropBoxField;
                        field.is_active = dropBoxCheck;
                        field.is_default = dropBoxDefault;
                    }
                } else if (dropBoxID <= +this.state.mandotory_count && dragBoxID <= +this.state.mandotory_count) {
                    if (field.label === states.drag_label_left) {
                        field.id = dropBoxID;
                        field.field_name = dragBoxField;
                        field.is_active = dragBoxCheck;
                        field.is_default = dragBoxDefault;
                    }
                    if (field.label === e.currentTarget.id) {
                        field.id = dragBoxID;
                        field.field_name = dropBoxField;
                        field.is_active = dropBoxCheck;
                        field.is_default = dropBoxDefault;
                    }
                }

                return field;
            });

            const SortData = newBoxState.sort((a, b) => { return a.id - b.id })

            this.setState({
                left_Fields_data: SortData,
                drag_label_left: null,
                drag_label: null,
            })
        }
    }

    vaidateDuplicate = (arr) => {
        let msg = null;
        const nameSet = new Set();
        const labelSet = new Set();
        arr?.forEach((item) => {
            if (labelSet.has(this.convertLowerCase(item.label)) || nameSet.has(this.convertLowerCase(item.custom_name))) {
                msg = `${labelSet.has(item.label) ? "System" : "Custom"} Name is duplicate`;
                return;
            }
            labelSet.add(this.convertLowerCase(item.label));
            nameSet.add(this.convertLowerCase(item.custom_name));
        });
        return msg;
    }

    canAddNewlayout = () => {
        return (this.state.max_new_layout_alloted - this.state.new_layout_count) > 1;
    }

    handleAddItem = (fromLastAdd = false) => {
        const newId = this.getNextId(this.state.left_Fields_data);
        this.setState((prevState) => {
            const updatedFields = [...prevState.left_Fields_data];
            if (updatedFields.length > 0) {
                updatedFields[updatedFields.length - 1] = {
                    ...updatedFields[updatedFields.length - 1],
                    is_newly_add: true
                };
            }
            return {
                left_Fields_data: fromLastAdd ? [...updatedFields]
                    : [...updatedFields, this.deepCopyObj({ ...defaultAddNew, id: newId })],
                new_layout_count: prevState?.new_layout_count + 1,
            };
        }, () => {
            if (fromLastAdd === false) {
                this.labelRefs[newId]?.focus();
            } else {
                this.postLayoutConfiguration()
            }
        })
    }

    renderDemoLayoutLeft = () => {
        let states = this.state;
        const isOptho = (this.state.isOPT || this.state.isOpthometry);
        return (
            <div style={{ height: "73vh", borderRight: "1px solid #D3D3D3", paddingRight: "0.5vw" }}>
                {(isOptho) ? null :
                    <Box sx={{ display: 'flex', padding: "0.4vw", marginLeft: "0.4vw", textAlign: 'center', border: "1px solid #B9B7BD", backgroundColor: 'white' }}>
                        <Box width={'50%'} sx={{ textAlign: 'left', paddingLeft: '1vw' }}><Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>System Name</Typography></Box>
                        <Box width={'50%'}><Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Custom Name</Typography></Box>
                    </Box>
                }
                {(states.left_Fields_data)
                    .map((item, index, arr) => {
                        const isAddBtn = (arr?.length - 1 === index) && this.canAddNewlayout();
                        const disableBtn = !(item?.label && item?.custom_name);
                        const isDraggable = isOptho ||
                            (!item?.is_new && !!item?.label && !!item?.custom_name) ||
                            (item?.is_new && !!item?.label && !!item?.custom_name && (item?.is_already_add === true || item?.is_newly_add === true)
                        );
                        
                        return (
                            <div style={{ paddingTop: "0.4vw", paddingLeft: "0.4vw" }}
                                key = {item.id}
                                draggable = {isDraggable}
                                onDragOver={(isDraggable) ? (e) => e.preventDefault() : undefined}
                                onDragStart={(isDraggable) ? this.handleDragLeft : undefined}
                                onDrop={(isDraggable) ? this.handleDropLeft : undefined} 
                                id={item.label}>
                                <Box border={'1px solid lightgray'} mb={'1vw'} display={'flex'} sx={{ backgroundColor: isOptho ? Colors.Background : 'white', flexDirection: isOptho ? 'column' : 'row' }}>
                                    <Box component={'div'} height={'2.5vw'} display={'flex'} pl={'0.5vw'} alignItems={'center'} width={'50%'}>
                                        <img className="eMed_demolayout_right2_field_img" src={ImagePaths.DragIndicator.default} alt="" style = {{visibility: isDraggable ? "visible" : "hidden"}}/>
                                        <FormControlLabel control={<Checkbox id={item.id} checked={item.is_active} onChange={this.handleCheckClickLeft} size='small' />}
                                         label={
                                            ((item.label && !item.is_new) || (item?.label && item.is_new && item.is_already_add)) ? (
                                              <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>
                                                {item.label}
                                              </Typography>
                                            ) : !isOptho  ? (
                                                <TextField
                                                autoComplete='off'
                                                size='small'
                                                sx={{marginTop: "0.1vw"}}
                                                inputProps={{ maxLength: 50 }}
                                                value={item.label ? item.label : ''}
                                                inputRef={(el) => {
                                                    if (el && item.is_new) {
                                                        this.labelRefs[item.id] = el;
                                                    }
                                                }}                                          
                                                onChange={(e) => {
                                                    item['label'] = e.target.value;
                                                    this.setState({
                                                        states
                                                    })
                                                }}
                                            /> ) : "-"
                                          } />
                                    </Box>
                                    {!isOptho ?
                                        <Box width={'50%'} sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "0.5dvw", paddingLeft: isAddBtn ? "3vw" : "" }}>
                                            <TextField
                                                size='small'
                                                inputProps={{ maxLength: 50 }}
                                                autoComplete='off'
                                                value={item.custom_name ? item.custom_name : ''}
                                                onChange={(e) => {
                                                    item['custom_name'] = e.target.value
                                                    this.setState({
                                                        states
                                                    })
                                                }}
                                            />
                                            {/* Show Add Button Only on Last Row */}
                                            {isAddBtn && <IconButton size = "small" 
                                            disabled = {disableBtn}
                                            variant='contained'sx={{width: "fit-content"}}
                                            onClick={() => {
                                                const errorMsg = this.vaidateDuplicate(arr);

                                                if (errorMsg) {
                                                    this.errorMessage(errorMsg)
                                                } else { 
                                                    this.handleAddItem()
                                                }
                                                }}>
                                                <img src={disableBtn ? ImagePaths.DisabledAddIcon.default : ImagePaths.AddIcon.default} alt="add" className='eMed_action_img' />
                                            </IconButton>
                                            }
                                        </Box>
                                        :
                                        <Box component={'div'} sx={{ backgroundColor: Colors.white, height: "7.5vw" }} p={'1vw'} borderBottom={'1px solid lightgray'}>
                                            <TableContainer component={'div'} sx={{ height: "15vh", overflowY: "scroll" }}>
                                                <Table aria-label="collapsible table" stickyHeader style={{ border: "1px solid #B9B7BD" }}>
                                                    <TableHead >
                                                        <TableRow>
                                                            <TableCell sx={{ width: '25vw', textAlign: "center" }} className="eMed_ABill_Head">{'Heading 1'}</TableCell>
                                                            <TableCell sx={{ width: '25vw', textAlign: "center" }} className="eMed_ABill_Head">{"Heading 2"}</TableCell>
                                                            <TableCell sx={{ width: '25vw', textAlign: "center" }} className="eMed_ABill_Head">{"Heading 3"}</TableCell>
                                                            <TableCell sx={{ width: '25vw', textAlign: "center" }} className="eMed_ABill_Head">{"Action"}</TableCell>
                                                        </TableRow>
                                                        <div style={{ height: "2.3vw" }}></div>
                                                    </TableHead>
                                                </Table>
                                            </TableContainer>
                                        </Box>
                                    }
                                </Box>
                            </div>
                        )
                    })}
            </div>
        )
    }

    handleDrag = (e) => {
        this.setState({
            drag_label: e.currentTarget.id
        })
    }

    handleCheckClick = (e) => {
        var { right_Fields_data } = this.state

        const ID = e.target.id;
        const Index = right_Fields_data.findIndex((data) => {
            return data.id == ID;
        });

        right_Fields_data[Index].is_active = e.target.checked;

        let lastChangedIndex = Index;

        for (let i = 0; i < right_Fields_data.length; i++) {
            if (i !== Index && right_Fields_data[i].is_active) {
                lastChangedIndex = i;
                break;
            }
        }

        if (right_Fields_data.every(data => !data.is_active)) {
            right_Fields_data[lastChangedIndex].is_active = true;
        }

        this.setState({
            right_Fields_data
        })
    }

    handleDrop = (e) => {
        var states = this.state
        const dragBox = (states.right_Fields_data).find((field) => field.label === states.drag_label);
        const dropBox = (states.right_Fields_data).find((field) => field.label === e.currentTarget.id);

        const matchingObject = (states?.left_Fields_data).find((item) => item.label === states?.drag_label_left);

        if (matchingObject) {
            this.errorMessage("Not Allow to Drag Left side values into Right")
            this.setState({
                drag_label_left: null
            })
        } else {

            const dragBoxID = dragBox.id;
            const dropBoxID = dropBox.id;

            const dragBoxField = dragBox.field_name;
            const dropBoxField = dropBox.field_name;

            const dragBoxCheck = dragBox.is_active;
            const dropBoxCheck = dropBox.is_active;

            // To make the default field also draggable.
            const dragBoxDefault = dragBox.is_default;
            const dropBoxDefault = dropBox.is_default;

            const newBoxState = (states.right_Fields_data).map((field) => {
                if ((!dragBoxDefault && !dropBoxDefault) || (dragBoxDefault && dropBoxDefault)) {
                    if (field.label === states.drag_label) {
                        field.id = dropBoxID;
                        field.field_name = dragBoxField;
                        field.is_active = dragBoxCheck;
                        field.is_default = dragBoxDefault;
                    }
                    if (field.label === e.currentTarget.id) {
                        field.id = dragBoxID;
                        field.field_name = dropBoxField;
                        field.is_active = dropBoxCheck;
                        field.is_default = dropBoxDefault;
                    }
                } else if (dropBoxID <= +this.state.mandotory_count && dragBoxID <= +this.state.mandotory_count) {
                    if (field.label === states.drag_label) {
                        field.id = dropBoxID;
                        field.field_name = dragBoxField;
                        field.is_active = dragBoxCheck;
                        field.is_default = dragBoxDefault;
                    }
                    if (field.label === e.currentTarget.id) {
                        field.id = dragBoxID;
                        field.field_name = dropBoxField;
                        field.is_active = dropBoxCheck;
                        field.is_default = dropBoxDefault;
                    }
                }

                return field;
            });

            const SortData = newBoxState.sort((a, b) => { return a.id - b.id })

            this.setState({
                right_Fields_data: SortData,
                drag_label_left: null,
                drag_label: null
            })
        }
    }


    renderDemoLayoutRight = () => {
        let states = this.state
        return (
            <div style={{ height: "73vh" }}>
                {(states.right_Fields_data)
                    .map((item, index) => {
                        return (
                            <div style={{ paddingTop: "0.4vw", paddingRight: "0.4vw" }}
                                draggable={true}
                                onDragOver={(e) => e.preventDefault()}
                                onDragStart={this.handleDrag}
                                onDrop={this.handleDrop}
                                id={item.label}>
                                <Box border={'1px solid lightgray'} mb={'1vw'}>
                                    <Box component={'div'} height={'2.5vw'} display={'flex'} pl={'0.5vw'} alignItems={'center'}>
                                        <img className="eMed_demolayout_right2_field_img" src={ImagePaths.DragIndicator.default} alt="" />
                                        <FormControlLabel control={<Checkbox id={item.id} checked={item.is_active} onChange={this.handleCheckClick} size='small' />} label={<Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{item.label}</Typography>} />
                                    </Box>
                                    <Box component={'div'} sx={{ backgroundColor: Colors.white, height: item.label === "Vitals" ? "16vw" : "4vw", display: "flex", alignItems: "center", justifyContent: 'center' }} p={'1vw'} borderBottom={'1px solid lightgray'}>
                                        <div style={{ color: "#B9B7BD", fontSize: "0.85vw", fontWeight: 600 }}>Add Content Here</div>
                                    </Box>
                                </Box>
                            </div>
                        )
                    })}
            </div>
        )
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    render() {
        return (
            <Box component={"div"} className='eMed_refdoc_container'>
                <div>
                    <Grid container spacing={1} style={{ height: "73vh", zIndex: 10, overflow: "scroll", paddingLeft: "0.5vw", paddingRight: "0.5vw" }} >
                        <Grid item xs={9}>
                            {this.renderDemoLayoutLeft()}
                        </Grid>
                        <Grid item xs={3}>
                            {this.renderDemoLayoutRight()}
                        </Grid>
                    </Grid>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", backgroundColor: "white", height: "2.7vw", zIndex: 99, paddingTop: "0.25vw" }}>
                        <Button variant='outlined' size="small" id="eMed_Config_btn" sx={{ mr: '0.5vw' }} onClick={() => {
                            this.setState({
                                right_Fields_data: this.returnDefaultLayout("right"),
                                left_Fields_data: this.returnDefaultLayout("left"),
                                new_layout_count: this.state.org_new_layout_count,
                            })
                        }} >{"RESET LAYOUT"}</Button>
                        <Button variant='contained' size="small" id="eMed_Config_btn" sx={{ ml: '0.5vw' }}
                            onClick={() => {
                                const lastItem = this.state.left_Fields_data[this.state.left_Fields_data.length - 1]; 
                                if ((this.state.max_new_layout_alloted - this.state.new_layout_count) === 1 && (lastItem.label && lastItem.custom_name)) { this.handleAddItem(true) }
                                else { this.postLayoutConfiguration() }
                            }}>
                            {"SAVE LAYOUT"}</Button>
                    </div>
                </div>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}